import React, { useMemo, useState } from "react";
import { Button, Icon, Modal, ModalActions, ModalContent, ModalHeader } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { cancelBoxThunk } from "../../../lib/store/thunks/conveyorBoxThunks";
import { AppDispatch } from "../../../lib/store/storeConfig";
import { useSelector } from "react-redux";
import { IConveyorBoxUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";

const CancelOrderButton = () => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const conveyorBoxReview: IConveyorBoxUI = useSelector(
    (state: any) => state.conveyorBoxReviewReducer
  );
  const hasPickedRxBag = useMemo(() => {
    return conveyorBoxReview.items.active.some(
      (item) => item.attributes?.includes("RXBAG") && item.pickedQuantity > 0
    );
  }, [conveyorBoxReview.items.active]);
  const onConfirmCancelOrderHandler = async () => {
    try {
      setIsLoading(true);
      await dispatch(cancelBoxThunk());
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      <Button
        style={{ gridColumn: "1 / -1" }}
        content={
          hasPickedRxBag ? "Innehåller sluten RX-Påse, går ej att avbryta order!" : "Avbryt order"
        }
        size="big"
        aria-label="Avbryt order"
        onClick={() => setShowConfirm(true)}
        disabled={isLoading || hasPickedRxBag}
        color="youtube"
      />
      {showConfirm && (
        <>
          <Modal
            dimmer="blurring"
            open={showConfirm}
            onClose={() => setShowConfirm(false)}
            size="small"
          >
            <ModalHeader>Oåterkallelig handling</ModalHeader>
            <ModalContent>Är du säker på att du vill avbryta ordern?</ModalContent>
            <ModalActions>
              <Button color="green" onClick={onConfirmCancelOrderHandler} loading={isLoading}>
                <Icon name="checkmark" /> Ja
              </Button>
              <Button color="red" onClick={() => setShowConfirm(false)}>
                <Icon name="remove" /> Nej
              </Button>
            </ModalActions>
          </Modal>
        </>
      )}
    </>
  );
};

export default CancelOrderButton;
